import { ReactNode } from 'react';
import styled from '@emotion/styled';

import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';
import { globalVariables } from '../../../shared/designSystem/constants';
import { sendClickLog } from '../../utils/sendClickLog';

import RedDot from '../GlobalNavItems/RedDot';

type Props = {
  label: string;
  link?: string;
  icon?: ReactNode;
  onClick?: () => void;
  alignCenter?: boolean;
  redDot?: boolean;
};

const baseClickLogData = {
  eventName: 'topmenu',
  screenName: WeblogScreenName.COMMON,
  pageCategory: WeblogPageCategory.COMMON,
  itemKind: 'menu',
};

export default function SideBarLink({ label, icon, link, alignCenter, onClick, redDot }: Props) {
  const handleClick = () => {
    if (link) {
      sendClickLog({
        ...baseClickLogData,
        itemName: label,
        targetUrl: link,
      });
    }

    onClick?.();
  };

  return (
    <Container href={link} onClick={handleClick} alignCenter={alignCenter}>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <LinkLabel>
        <LabelText>{label}</LabelText>
        {redDot && <RedDot />}
      </LinkLabel>
    </Container>
  );
}

const Container = styled.a<{ alignCenter?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 15px;
  font-weight: 500;
  color: ${globalVariables.gray_700};

  &:not(:last-of-type) {
    margin-bottom: 20px;
  }

  justify-content: ${({ alignCenter }) => (alignCenter ? 'center' : 'flex-start')};
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`;

const LinkLabel = styled.div`
  position: relative;
  width: auto;
`;

const LabelText = styled.span`
  padding-right: 10px;
`;
